import React, { useState } from "react";
import { TitleButtons } from "../../components/style/TitleButtons";
import { Heading } from "../../components/style/Heading";

const BoardMaterial = ({
  activeStep,
  items,
  onComplete,
  setActiveProduct,
  manager,
  setOverrideStep,
}) => {
  const { state } = manager;

  return (
    <>
      <Heading
        isActive={activeStep}
        completed={state.completedBoard}
        completedAttr={"completedBoard"}
        setState={manager.setState}
        onClick={() => setOverrideStep(-1)}
        title={"Materijal ploče"}
      />
      {activeStep && (
        <div className="styling-wrap__contents | js-conf-styling-wrap-content">
          <TitleButtons
            title={"Izbor materijala ploče"}
            items={items}
            activeItem={state.boardMaterial}
            setActiveItem={(item) => manager.selectBoardMaterial(item)}
            handleComplete={() => {
              manager.setState((prev) => ({
                ...prev,
                completedBoard: true,
              }));
              onComplete();
            }}
            setActiveProduct={setActiveProduct}
          />
        </div>
      )}
    </>
  );
};

export default BoardMaterial;
